import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollManager from "@/components/ScrollManager";
import Home from "@/pages/Home";
import Experiences from "@/pages/Experiences";
import ExperienceDetail from "@/pages/ExperienceDetail";
import OriginalSeries from "@/pages/OriginalSeries";
import Apply from "@/pages/Apply";
import Community from "@/pages/Community";
import About from "@/pages/About";
import Partnerships from "@/pages/Partnerships";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";
import CastingPrivate from "@/pages/CastingPrivate";
import FeatureYourBusiness from "@/pages/FeatureYourBusiness";
import FeaturedArchive from "@/pages/FeaturedArchive";
import FeatureReupload from "@/pages/FeatureReupload";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollManager />
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/experiences" element={<Experiences />} />
                    <Route path="/experiences/:slug" element={<ExperienceDetail />} />
                    <Route path="/experiences/:slug/confirmation" element={<PaymentResult />} />
                    <Route path="/original-series" element={<OriginalSeries />} />
                    <Route path="/apply" element={<Apply />} />
                    <Route path="/apply/private/:token" element={<CastingPrivate />} />
                    <Route path="/apply/private/:token/thanks" element={<PaymentResult />} />
                    <Route path="/community" element={<Community />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/partnerships" element={<Partnerships />} />
                    <Route path="/feature-your-business" element={<FeatureYourBusiness />} />
                    <Route path="/featured" element={<FeaturedArchive />} />
                    <Route path="/feature/reupload/:token" element={<FeatureReupload />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/admin/*" element={<Admin />} />
                    <Route path="/payment-result" element={<PaymentResult />} />
                </Routes>
                <Footer />
                <Toaster theme="dark" position="top-center" />
            </BrowserRouter>
        </div>
    );
}

export default App;
